import axios from 'axios';

const GET_CUSTOMER_CONTRACT_DETAILS = '/.netlify/functions/getCustomerContractDetails';

const GetCustomerContractDetails = async (username: string) => {

  const fetchData = async(): Promise<any> => {
    try {
      let results = await axios.post(GET_CUSTOMER_CONTRACT_DETAILS,{
        userName: username
      },{
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if(results.status == 200) {
        return results.data;
      } else {
        return []
      }
    } catch( err) {
      console.log(err);
    }
  };

  return await fetchData();
};

export default GetCustomerContractDetails;